import Vue from 'vue'
import VueRouter from 'vue-router'
import inlet from './inlet/index' // 首页   
const menuData = require('@/layout/menu.js')
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/index.vue'),
    children: [
      {
        path: '',
        name: 'workbench',
        component: () => import('@/views/workbench/index.vue'),
        meta: {
          title: '工作台'
        }
      }, {
        path: '/mine',
        name: 'mine',
        component: () => import('@/views/workbench/mine.vue'),
        meta: {
          isMenuOpens: '工作台',
          title: '个人中心',
        }
      }, {
        path: '/messageCenter',
        name: 'messageCenter',
        component: () => import('@/views/workbench/messageCenter.vue'),
        meta: {
          isMenuOpens: '消息中心',
          title: '信息列表',
        }
      }, {
        path: '/OfficialDocumentDetial',
        name: 'OfficialDocumentDetial',
        component: () => import('@/views/OfficialDocument/detial.vue'),
        meta: {
          isMenuOpens: '公文发文',
          title: '公文详情',
        }
      }, {
        path: '/BriefReportDetial',
        name: 'BriefReportDetial',
        component: () => import('@/views/BriefReport/detial.vue'),
        meta: {
          isMenuOpens: '简报',
          title: '详情',
        }
      },
      {
        path: '/InformTheForwardingDetial',
        name: 'InformTheForwardingDetial',
        component: () => import('@/views/InformTheForwarding/detial.vue'),
        meta: {
          isMenuOpens: '公文转发',
          title: '公文登记详情',
        }
      }, {
        path: '/newsList',
        name: 'newsList',
        component: () => import('@/views/workbench/newsList.vue'),
        meta: {
          isMenuOpens: '工作台',
          title: '信息列表'
        }
      }, {
        path: '/newsDetial',
        name: 'newsDetial',
        component: () => import('@/views/workbench/newsDetial.vue'),
        meta: {
          isMenuOpens: '新闻管理',
          title: '公司新闻'
        }
      },
      {
        path: '/TheBusinessApplication',
        name: 'TheBusinessApplication',
        component: () => import('@/views/workbench/TheBusinessApplication.vue'),
        meta: {
          isMenuOpens: '工作台',
          title: '业务申请'
        }
      },]
  },
  // ...inlet,    //v 本地测试用  发版注释掉
  {
    path: '/upgrade',
    name: 'upgrade',
    component: () => import('@/views/upgrade.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/404')
  },
  {
    path: '*',
    component: () => import('@/views/403')
  }
]
// const router = new VueRouter({
//   routes,
//   mode: 'history'
//   // mode: 'hash'
// })
// 动态路由
const createRouter = () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})


//防止重复跳转统一页面路由报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js